import React from 'react';
import { PointExpireRunContainerStyled } from './styled';
import { withRouter } from 'navigations/withRouter';
import { Displays, Inputs, Tables } from 'components';
import { scrollToTopPageFN } from 'utils/functions/scrollTopPage';
import { portalService } from 'apiServices';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import moment from 'moment';
import 'moment-timezone';
import { MdFileDownload, MdList } from 'react-icons/md';
import { ROUTE_PATH } from 'utils/constants/routePath';
import {
  parseFilterQuery,
  syncFilterUrlQuery,
} from 'utils/functions/filterQuery';
import {
  TIME_ZONE,
  formatDateTime,
  formatPoint,
  PERIOD_OPTIONS,
  POINT_EXPIRE_LOG_SHEET_COLS,
  POINT_EXPIRE_LOG_SHEET_HEADER,
  POINT_EXPIRE_LOG_SHEET_ROW,
  RENDER_RUN_STATUS,
  RENDER_TRIGGER,
  RUN_STATUS_OPTIONS,
} from 'utils/functions/pointExpire';

const FILTER_FIELDS = ['period_key', 'status'];

// ประกอบ query จากค่า filter โดยตัดค่าว่างและ "All" ('0') ทิ้ง
const buildQuery = (filterValues) => {
  const searchParams = new URLSearchParams();
  FILTER_FIELDS.forEach((key) => {
    const value = filterValues[key];
    if (value && value !== '0') searchParams.set(key, value);
  });
  const query = searchParams.toString();
  return query ? `?${query}` : '';
};

const stateFromSearch = (search) => {
  const parsed = parseFilterQuery(search, FILTER_FIELDS);
  return {
    filterValues: parsed.filterValues,
    filterQuery: buildQuery(parsed.filterValues),
    currentPage: parsed.currentPage,
  };
};

// ประวัติรอบการตัดแต้ม (point_expire_run) 1 รอบ = การรัน cron/script 1 ครั้งต่อล็อต
class PointExpireRunContainer extends React.Component {
  state = {
    isLoading: true,
    isBgLoading: false,
    isPeriodLoading: true,
    periodOptions: [{ label: 'All', value: '0' }],
    pagination: null,
    perPage: 10,
    data: [],
    filterKey: 0,
    ...stateFromSearch(this.props.router.location.search),
  };

  componentDidMount() {
    const { filterQuery, currentPage } = this.state;
    scrollToTopPageFN();
    this.fetchPeriods();
    this.handleJoinQuery(filterQuery, currentPage);
  }

  fetchPeriods = async () => {
    let res = await portalService.GET_POINT_EXPIRE_PERIODS();
    this.setState({
      isPeriodLoading: false,
      periodOptions:
        res && res.status === 200
          ? PERIOD_OPTIONS(res.data.periods, { withAll: true })
          : [{ label: 'All', value: '0' }],
    });
  };

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_POINT_EXPIRE_RUN_LIST(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
        },
      });
    } else {
      this.setState({ data: [], isLoading: false, pagination: null });
      toast.error('โหลดข้อมูลไม่สำเร็จ');
    }
  };

  handleJoinQuery = (query, page) => {
    const { perPage } = this.state;
    let joinQuery = query
      ? `${query}&limit=${perPage}&page=${page}`
      : `?limit=${perPage}&page=${page}`;
    this.setState({
      isLoading: true,
      currentPage: page,
    });
    syncFilterUrlQuery(this.props.router, query, page);
    this.fetchData(joinQuery);
  };

  handleFilterKeyword = (e) => {
    const parsed = parseFilterQuery(e, FILTER_FIELDS);
    const filterQuery = buildQuery(parsed.filterValues);
    this.setState({ filterValues: parsed.filterValues, filterQuery });
    this.handleJoinQuery(filterQuery, 1);
  };

  handleClearFilter = () => {
    this.setState((prevState) => ({
      ...stateFromSearch(''),
      filterKey: prevState.filterKey + 1,
    }));
    this.handleJoinQuery('', 1);
  };

  handlePageClick = (e) => {
    const { filterQuery } = this.state;
    this.handleJoinQuery(filterQuery, e.selected + 1);
  };

  // ไปหน้า Expire history โดยกรองเฉพาะรายการของรอบนี้
  handleClickViewLogs = (row) => {
    this.props.router.navigate(
      `${ROUTE_PATH.POINT_EXPIRE_HISTORY}?run_ref_id=${row._id}`
    );
  };

  // Export รายการตัดแต้มทั้งหมดของรอบนี้ (คอลัมน์เดียวกับหน้า Expire history)
  handleExportRun = async (row) => {
    if (this.isExporting) return;
    this.isExporting = true;
    this.setState({ isBgLoading: true });
    let res = await portalService.GET_POINT_EXPIRE_LOG_LIST(
      `?run_ref_id=${row._id}&pagination=false`
    );
    this.isExporting = false;
    this.setState({ isBgLoading: false });
    if (!res || res.status !== 200) {
      toast.error('Export ไม่สำเร็จ');
      return;
    }
    if (!res.data.docs || res.data.docs.length === 0) {
      toast.info('รอบนี้ไม่มีรายการตัดแต้ม');
      return;
    }
    var wb = XLSX.utils.book_new();
    var ws_name = 'SheetJS';
    var ws_data = res.data.docs.map(POINT_EXPIRE_LOG_SHEET_ROW);
    ws_data.splice(0, 0, POINT_EXPIRE_LOG_SHEET_HEADER);
    var ws = XLSX.utils.aoa_to_sheet(ws_data);
    ws['!cols'] = POINT_EXPIRE_LOG_SHEET_COLS;
    XLSX.utils.book_append_sheet(wb, ws, ws_name);
    XLSX.writeFile(
      wb,
      `Point expire ${row.period_key} ${moment()
        .tz(TIME_ZONE)
        .format('DD-MM-YYYY')}.xlsx`
    );
  };

  render() {
    const {
      isLoading,
      isBgLoading,
      isPeriodLoading,
      periodOptions,
      pagination,
      data,
      filterValues,
      filterKey,
    } = this.state;

    return (
      <PointExpireRunContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="filter_layout">
          {!isPeriodLoading && (
            <Inputs.InputFilter
              key={filterKey}
              theme_standard_input_filter
              dataFilter={dataFilter(filterValues, periodOptions)}
              btnLabel="ค้นหา"
              clearLabel="ล้างค่า"
              onQueryFilter={this.handleFilterKeyword}
              onClear={this.handleClearFilter}
            />
          )}
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="470px" />
        ) : (
          <div className="table_wrap">
            <Tables.Standard
              columns={columns({
                onViewLogs: this.handleClickViewLogs,
                onExport: this.handleExportRun,
              })}
              data={data}
              showPagination
              pagination={pagination}
              handlePageClick={this.handlePageClick}
            />
          </div>
        )}
      </PointExpireRunContainerStyled>
    );
  }
}

const dataFilter = (filterValues, periodOptions) => [
  {
    accessor: 'period_key',
    length: '360px',
    filter: {
      fieldQuery: 'period_key',
      type: 'dropdown',
      defaultValue: filterValues.period_key,
      options: periodOptions,
      placeholder: 'ล็อต',
      label: 'ล็อต : ',
    },
  },
  {
    accessor: 'status',
    length: '200px',
    filter: {
      fieldQuery: 'status',
      type: 'dropdown',
      defaultValue: filterValues.status,
      options: RUN_STATUS_OPTIONS,
      placeholder: 'สถานะ',
      label: 'สถานะ : ',
    },
  },
];

const numberCell = (props) => (
  <div style={{ textAlign: 'right' }}>{formatPoint(props.value)}</div>
);

const columns = ({ onViewLogs, onExport }) => [
  {
    Header: <div style={{ textAlign: 'left' }}>เวลาเริ่ม</div>,
    accessor: 'started_at',
    Cell: (props) => (
      <div className="nowrap">
        {formatDateTime(props.value || props.row.original.created_at)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>เวลาจบ</div>,
    accessor: 'finished_at',
    Cell: (props) => <div className="nowrap">{formatDateTime(props.value)}</div>,
  },
  {
    Header: <div style={{ textAlign: 'left' }}>ล็อต</div>,
    accessor: 'period_key',
  },
  {
    Header: <div style={{ textAlign: 'left' }}>ตัดโดย</div>,
    accessor: 'trigger',
    Cell: (props) => (
      <div>
        {RENDER_TRIGGER(props.value)}
        {props.row.original.admin_username && (
          <div className="sub_text">{props.row.original.admin_username}</div>
        )}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'center' }}>สถานะ</div>,
    accessor: 'status',
    Cell: (props) => (
      <div style={{ textAlign: 'center' }}>
        <span className={`status_badge status_${props.value}`}>
          {RENDER_RUN_STATUS(props.value)}
        </span>
        {props.row.original.error_message && (
          <div className="error_text" title={props.row.original.error_message}>
            {props.row.original.error_message}
          </div>
        )}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'right' }}>ลูกค้าทั้งหมด</div>,
    accessor: 'customer_count',
    Cell: numberCell,
  },
  {
    Header: <div style={{ textAlign: 'right' }}>ที่จะตัด</div>,
    accessor: 'expiring_customer_count',
    Cell: numberCell,
  },
  {
    Header: <div style={{ textAlign: 'right' }}>สำเร็จ</div>,
    accessor: 'success_count',
    Cell: numberCell,
  },
  {
    Header: <div style={{ textAlign: 'right' }}>ไม่สำเร็จ</div>,
    accessor: 'fail_count',
    Cell: (props) => (
      <div
        style={{ textAlign: 'right' }}
        className={Number(props.value) > 0 ? 'danger_value' : ''}
      >
        {formatPoint(props.value)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'right' }}>ข้าม</div>,
    accessor: 'skipped_done_count',
    Cell: numberCell,
  },
  {
    Header: <div style={{ textAlign: 'right' }}>ต้องตรวจ</div>,
    accessor: 'needs_review_count',
    Cell: (props) => (
      <div
        style={{ textAlign: 'right' }}
        className={Number(props.value) > 0 ? 'warn_value' : ''}
      >
        {formatPoint(props.value)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'right' }}>ยอดไม่ตรง</div>,
    accessor: 'mismatch_count',
    Cell: (props) => (
      <div
        style={{ textAlign: 'right' }}
        className={Number(props.value) > 0 ? 'warn_value' : ''}
      >
        {formatPoint(props.value)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'right' }}>แต้มรวมที่ตัด</div>,
    accessor: 'total_point',
    Cell: (props) => (
      <div style={{ textAlign: 'right' }} className="expire_value">
        {formatPoint(props.value)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>หมายเหตุ</div>,
    accessor: 'remark',
    Cell: (props) =>
      props.value ? (
        <div className="remark_text" title={props.value}>
          {props.value}
        </div>
      ) : (
        '-'
      ),
  },
  {
    Header: <div style={{ textAlign: 'center' }}>Action</div>,
    accessor: '_id',
    Cell: (props) => (
      <div className="action_cell">
        <span
          className="link_btn"
          onClick={() => onViewLogs(props.row.original)}
        >
          <MdList size={14} />
          ดูรายการ
        </span>
        <span
          className="link_btn link_export"
          onClick={() => onExport(props.row.original)}
        >
          <MdFileDownload size={14} />
          Export Excel
        </span>
      </div>
    ),
  },
];

export default withRouter(PointExpireRunContainer);
